import { FC } from "react";
import { Customer } from "@/pages/Shop/Invoice/forms/type";
import { LegacyCard, Space, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils";

interface Props {
  item: Customer;
}

const CreateCustomerCard: FC<Props> = ({ item }) => {
  const { t } = useAppTranslation();

  return (
    <LegacyCard.Ant className={"mb-1"}>
      <Space orientation={"vertical"} size={"middle"} className={"tw:w-full"}>
        <div className={"tw:flex tw:justify-between"}>
          <Typography.Text>
            {item.type === "category"
              ? t("invoice.create.base.createCustomerCard.groupTitle")
              : t("invoice.create.base.createCustomerCard.name")}
            :
          </Typography.Text>
          <Typography.Text type={"secondary"}>{item.fullName}</Typography.Text>
        </div>
        {item.phoneNumber ? (
          <div className={"tw:tw:flex tw:flex tw:justify-between"}>
            <Typography.Text>{`${t("common.mobile")}:`}</Typography.Text>
            <Typography.Text type={"secondary"}>{item.phoneNumber}</Typography.Text>
          </div>
        ) : null}
        {item.email ? (
          <div className={"tw:tw:flex tw:flex tw:justify-between"}>
            <Typography.Text>{`${t("common.email")}:`}</Typography.Text>
            <Typography.Text type={"secondary"}>{item.email || "-"}</Typography.Text>
          </div>
        ) : null}
      </Space>
    </LegacyCard.Ant>
  );
};

export default CreateCustomerCard;
